import { InitFF } from "./types";

const initializeFeatureFlag = <
  T extends Record<string, string>,
  F extends keyof InitFF<T>["FLAGS_ENUM"]
>({
  FEATURE_FLAGS,
  FLAGS_ENUM,
}: InitFF<T>): {
  useFeatureFlag: (flag: F | F[]) => boolean | boolean[];
} => {
  const useFeatureFlag = (flag: F | F[]) => {
    const isParamInvalid = typeof flag !== "string" && !Array.isArray(flag);

    if (!flag || isParamInvalid) {
      throw new Error("must be a string or an array of strings");
    }

    if (Array.isArray(flag)) {
      return flag.map((f) => FEATURE_FLAGS[FLAGS_ENUM[f]] === "true");
    }

    return FEATURE_FLAGS[FLAGS_ENUM[flag]] === "true";
  };

  return { useFeatureFlag };
};

export { initializeFeatureFlag };
